import { useState } from "react"
import Modal from "../../../../molecules/Modal"
import Button from "../../../../atoms/Button"
import styles from "./index.module.scss"
import LinkShareIcon from "../../../../../assets/icons/LinkShareIcon"
import WarningIcon from "../../../../../assets/icons/Warning"
import intl from "react-intl-universal"
import { useLocation } from "react-router-dom"

export const ModalVinculateAnalytes = ({
  children,
  onCancel,
  listHistory,
  onClick,
  listAnalytesAddEquipment,
}) => {
  const [isInfoCancel, setIsInfoCancel] = useState(false)
  const location = useLocation()
  const bPageEquipment = location.pathname.includes("equipment")

  return isInfoCancel ? (
    <Modal isOpen={true} size={isInfoCancel ? "md" : "lg"}>
      <Modal.Header
        style={{
          padding: "0.5rem",
        }}
        onClose={onCancel}
      >
        <h1 className={styles.titleModal}>
          {intl.get("ciq.list_analytes.add_exame_analyte")}
        </h1>
      </Modal.Header>

      <Modal.Content
        style={{
          maxWidth: "100%",
          padding: "0rem  1rem",
        }}
      >
        <div className={styles.flexCenter}>
          <WarningIcon />
          <p className={styles.paragraph}>{intl.get("ciq.changes_not_save")}</p>
        </div>
      </Modal.Content>
      <div className={styles.containerButton}>
        <Button
          type="button"
          variant="outline"
          onClick={() => {
            setIsInfoCancel(false)
          }}
        >
          {intl.get("activityModelModal.close_when_change_field_cancel")}
        </Button>
        <Button
          style={{ background: "#1ECB4F" }}
          type="button"
          onClick={() => {
            onCancel()
          }}
        >
          {intl.get("ciq.yes_continue")}
        </Button>
      </div>
    </Modal>
  ) : (
    <Modal isOpen={true} size={isInfoCancel ? "md" : "lg"}>
      <Modal.Header
        style={{
          padding: "0.5rem",
        }}
        onClose={() => setIsInfoCancel(true)}
      >
        <h1 className={styles.titleModal}>
          {intl.get("ciq.list_analytes.add_exame_analyte")}
        </h1>
      </Modal.Header>

      <Modal.Content style={{ maxWidth: "100%", padding: "0rem  1rem" }}>
        <p className={styles.paragraph}>{intl.get("ciq.select_analyte_to_add")}</p>

        {children}
      </Modal.Content>
      <div className={styles.containerButton}>
        <Button
          type="button"
          variant="outline"
          onClick={() => {
            setIsInfoCancel(true)
          }}
        >
          {intl.get("cancel")}
        </Button>
        <Button
          type="button"
          onClick={() => {
            if (bPageEquipment) {
              const newData = listHistory.map((item) => {
                return {
                  anlt_cname: item.anlt_cname,
                  anlt_type: item.anlt_type,
                  anlt_ruler: "---",
                  anlt_imprecision: "---",
                  anlt_nid: item.anlt_nid,
                  anlt_bstatus: !item.anlt_bstatus
                    ? intl.get("ciq.list_analytes.active")
                    : intl.get("ciq.list_analytes.inactive"),
                  bChecked: false,
                }
              })
              const orderAlphabetic = listAnalytesAddEquipment
                .concat(newData)
                .sort((a, b) => {
                  const nameA = a.anlt_cname.toUpperCase()
                  const nameB = b.anlt_cname.toUpperCase()

                  if (nameA < nameB) {
                    return -1
                  }
                  if (nameA > nameB) {
                    return 1
                  }
                  return 0
                })
              onClick(orderAlphabetic)
              onCancel()
            } else {
              const newData = listHistory.map((item) => {
                return {
                  anlt_cname: item.anlt_cname,
                  anlt_type: item.anlt_type,
                  anlt_info: "---",
                  anlt_nid: item.anlt_nid,
                  anlt_bstatus: !item.anlt_bstatus,
                  anlt_result_options: item.anlt_result_options,
                  bChecked: false,
                }
              })

              const orderAlphabetic = listAnalytesAddEquipment
                .concat(newData)
                .sort((a, b) => {
                  const nameA = a.anlt_cname.toUpperCase()
                  const nameB = b.anlt_cname.toUpperCase()

                  if (nameA < nameB) {
                    return -1
                  }
                  if (nameA > nameB) {
                    return 1
                  }
                  return 0
                })

              onClick(orderAlphabetic)
              onCancel()
            }
          }}
        >
          <LinkShareIcon
            style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }}
          />
          {intl.get("ciq.list_analytes.add_exame_analyte")}
        </Button>
      </div>
    </Modal>
  )
}
